import axios from 'axios';

export const cartSummary = async (userToken, userSession) => {  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://mcstaging.candere.com/rest/default/V1/carts/mine/totals',
    headers: { 
      'Authorization': `Bearer ${userToken}`,
    },
    withCredentials: true,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};
